import React from 'react';
import { Mail } from 'lucide-react';
import styles from './SendMessageStep.module.css';

interface EmptyEmailPreviewProps {
  onEdit: () => void;
}

export const EmptyEmailPreview: React.FC<EmptyEmailPreviewProps> = ({ onEdit }) => (
  <button type="button" className={styles.emptyState} onClick={onEdit}>
    <Mail />
    <strong>Edit Email Template</strong>
    <span>Click to open the visual email designer</span>
  </button>
);
